module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo-sp.62fc54da.jpg";